import { render } from "./MsTextArea.vue?vue&type=template&id=6757fda5"
import script from "./MsTextArea.vue?vue&type=script&lang=js"
export * from "./MsTextArea.vue?vue&type=script&lang=js"

import "./MsTextArea.vue?vue&type=style&index=0&id=6757fda5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__